import * as React from 'react';

interface FilterContext {
    availableFilters: string[];
    selectedFilter: string | null;
    setSelectedFilter: (query: string | null) => void;
    isSticky?: boolean;
}

export const FilterContext = React.createContext<FilterContext>({
    availableFilters: [],
    selectedFilter: null,
    setSelectedFilter: () => {},
    isSticky: false,
});
